<template>
  <div class="py-20 md:py-24">
    <div class="container-center-horizontal page">
      <div class="cookies_policy_template">
        <div class="side_nav">
          <div
            class="cookies"
            :class="[
              isCompSelected == 'cookies-template' ? 'all_files_active' : null,
            ]"
            @click="setSelectedComp('cookies-template')"
          >
            Cookies
          </div>
          <div
            class="cookies"
            :class="[
              isCompSelected == 'privacy-policy-template'
                ? 'all_files_active'
                : null,
            ]"
            @click="setSelectedComp('privacy-policy-template')"
          >
            Privacy Policy
          </div>
          <div
            class="cookies"
            :class="[
              isCompSelected == 'terms-conditions' ? 'all_files_active' : null,
            ]"
            @click="setSelectedComp('terms-conditions')"
          >
            Terms and Conditions
          </div>
        </div>
        <div class="content">
          <component :is="isCompSelected" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import TermsConditions from './TermsConditions.vue';
import CookiesTemplate from './CookiesTemplate.vue';
import PrivacyPolicyTemplate from './PrivacyPolicyTemplate.vue';
export default {
  components: {

    TermsConditions,
    PrivacyPolicyTemplate,
    CookiesTemplate,
  },
  data() {
    return {
      isCompSelected: 'cookies-template',
    };
  },
  methods: {
    setSelectedComp(val) {
      this.isCompSelected = val;
    },
  },
};
</script>

<style scoped>
.cookies_policy_template {
  display: flex;
  flex: 1;
  flex-direction: row;
}
.side_nav {
  flex: 0.1;
  display: flex;
  flex-direction: column;
  height: 100vh;
  color: var(--djuli-primary-color);
  border-right: 1px solid;
  justify-content: flex-start;
}
.content {
  flex: 0.9;
  padding: 1rem;
  overflow-y: auto;
  height: 90vh;
  line-height: 1.5rem;
  letter-spacing: 1px;

}

.content {
  font-family: Helvetica;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.content::-webkit-scrollbar {
  display: none;
}
.page {
  height: 100vh;
}

.cookies {
  padding: 1rem;
  color: var(--djuli-primary-color);
}
.margin_footer {
  margin-top: 3rem;
}
.all_files_active {
  border-bottom: 1px solid #6a60ce;
  border-left: 1px solid #6a60ce;
  color: #6a60ce;
  padding: 8px;
}
</style>